import { IntegrationSystem } from '@/shared/types';

import type { LabelValue, DataResponse } from './common';

export enum ERZExtractKind {
  WEAPON_PURCHASE = 'E004',
  STORAGE_CARRYING_WEAPON = 'E005',
  STORAGE_CARRYING_PRIZE_WEAPON = 'EI04',
  STORAGE_CARRYING_COLD_STEEL = 'EI05',
  WEAPON_RE_REGISTRATION = 'E013',
  ALL_EXISTING_PERMITS = 'R005',

  IMPORT_AND_EXPORT_WEAPON = 'E008',

  OPEN_AND_OPERATE_WITH_EXPLOSIVE_MATERIALS = 'E001',
  EXPLOSIVE_MATERIALS_PURCHASE = 'E002',
  EXPLOSIVE_MATERIALS_TRANSPORTATION = 'E003',
  DEPARTMENT_WEAPONS_CARRYING = 'E007',
  IMPORTED_ITEMS_USAGE = 'E009',
  DEPARTMENT_WEAPONS_RE_REGISTRATION = 'E012',
  COMMISSION_SALE = 'E014',
}

export type ErzSearchQueryParams = {
  numb: string;
  secret: string;
};

export enum ExtractInfoType {
  INFO = 'info',
  WARNING = 'warning',
  DANGER = 'danger',
}

export interface ExtractInfo {
  type: ExtractInfoType;
  message: string;
}

export interface ExtractDetails<T extends IntegrationSystem>
  extends Record<'kind', T extends IntegrationSystem.ERZ ? ERZExtractKind : null>, DataResponse<LabelValue[]> {
  info: Nullable<ExtractInfo>;
}

export type ResponseExtract<T extends IntegrationSystem> = DataResponse<ExtractDetails<T>>;
